










import { Component, Vue, Prop } from 'vue-property-decorator'
import firebase from '@/plugins/firebase'
import tripCollection, { Trip } from '@/models/trip'
import deviceCollection, { Device } from '@/models/device'
import moment from '@/plugins/moment'
import DashboardCardTripCalendar from '@/components/common/DashboardCardTripCalendar.vue'

@Component<DashboardLayoutDay>({
  components: {
    DashboardCardTripCalendar
  },
  mounted () {
    this.fetch()
  }
})
export default class DashboardLayoutDay extends Vue {
  @Prop({ type: String, required: true }) phoneNumber!: string
  loading = true
  empty = true
  docs: firebase.firestore.QueryDocumentSnapshot<Trip>[] = []

  get deviceRef (): firebase.firestore.DocumentReference<Device> {
    return deviceCollection.doc(this.phoneNumber)
  }

  get ref (): firebase.firestore.Query<Trip> {
    const currentDate = moment()
    return tripCollection.where('device', '==', this.deviceRef)
      .where('firstSecond.time', '>=', currentDate.startOf('months').utcOffset(9).toISOString())
      .where('firstSecond.time', '<', currentDate.endOf('months').utcOffset(9).add(1, 'days').toISOString())
      .orderBy('firstSecond.time', 'asc')
      .limit(400)
  }

  get xs (): boolean {
    return this.$vuetify.breakpoint.xs
  }

  async fetch (): Promise<void> {
    if (!this.phoneNumber) return
    try {
      this.loading = true
      const sn = await this.ref.get()
      this.empty = sn.empty
      if (sn.empty) return
      this.docs = sn.docs
    } finally {
      this.loading = false
    }
  }
}
